/**
 * Tiny shared math helpers. Kept dependency-free so anything (CPU terrain
 * gen, animation blending, AI tick, GUI tween) can pull them in without
 * dragging Babylon's full math kit along.
 */

export function smoothstep(edge0: number, edge1: number, x: number): number {
  const t = Math.max(0, Math.min(1, (x - edge0) / (edge1 - edge0)));
  return t * t * (3 - 2 * t);
}

export function clamp(x: number, lo: number, hi: number): number {
  return x < lo ? lo : x > hi ? hi : x;
}

export function clamp01(x: number): number {
  return x < 0 ? 0 : x > 1 ? 1 : x;
}

/** Wrap an angle into (−π, π] so we don't flip sign across the seam. */
export function wrapAngle(a: number): number {
  const TAU = Math.PI * 2;
  let x = ((a + Math.PI) % TAU + TAU) % TAU - Math.PI;
  if (x === -Math.PI) x = Math.PI;
  return x;
}

export function randRange(lo: number, hi: number): number {
  return lo + Math.random() * (hi - lo);
}
